import {FormikProps} from 'formik';
import {IInfoFormValues} from '../infoFormValues';

interface IProps {
  form: FormikProps<IInfoFormValues>;
}

const DeliveryTypeField = ({form}: IProps) => {
  return (
    <div>
      <span className="mb-2 text-gray-800 text-md">
        نوع تحویل <span className="text-red-500">*</span>
      </span>

      <div className="mt-2 space-y-2">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            className="accent-farm-shop-500"
            name="deliveryType"
            value="in-person"
            checked={form.values.deliveryType === 'in-person'}
            onChange={() =>
              form.setFieldValue('deliveryType', 'in-person', true)
            }
          />

          <p className="p-0 m-0 text-gray-700 text-md">
            تحویل حضوری <span className="mr-2 text-gray-500">رایگان</span>
          </p>
        </label>

        <label className="flex items-center gap-2">
          <input
            type="radio"
            className="accent-farm-shop-500"
            name="deliveryType"
            value="seller"
            checked={form.values.deliveryType === 'seller'}
            onChange={() => form.setFieldValue('deliveryType', 'seller', true)}
          />

          <p className="p-0 m-0 text-gray-700 text-md">
            ارسال فروشنده{' '}
            <span className="mr-2 text-gray-500">
              هزینه ارسال با تیپاکس یا باربری
            </span>
          </p>
        </label>
      </div>
    </div>
  );
};

export default DeliveryTypeField;
